import { render, staticRenderFns } from "./MacrosCategoryEdit.vue?vue&type=template&id=d4e452da"
import script from "./MacrosCategoryEdit.vue?vue&type=script&lang=js"
export * from "./MacrosCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports